import UpdateDeliveryOrder from "../../../../components/@documents/delivery_orders/UpdateDeliveryOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function DeliveryOrderUpdatePage() {

    return (
        <UpdateDeliveryOrder 
            routeType={routeTypes.workstation}
        />
    )
}